// import { Debugging } from 'config';
import { loadScript } from 'lib/helpers';

const appWindow = (window as any);

export default class AppcuesService {
  static instance: AppcuesService;
  private initialized: boolean = false;

  static getInstance(): AppcuesService {
    return AppcuesService.instance
      ? AppcuesService.instance
      : (AppcuesService.instance = new AppcuesService());
  }

  getAppcues () {
    return appWindow.Appcues;
  }

  identify (user: any) {
    if (appWindow.Appcues) {
      appWindow.Appcues.identify(user.id, {
        name: user.name,
        last_name: user.last_name,
        role: user.role,
        email: user.email,
        organization: user.organization,
        center: user.center,
        classroom: user.classroom,
        language: user.language,
      });
      // if (Debugging) {
      //   appWindow.Appcues.debug();
      // }
    }
  }

  page () {
    if (appWindow.Appcues) {
      appWindow.Appcues.page();
    }
  }

  isInitialized () {
    return this.initialized;
  }

  initialize = () => {
    return new Promise((resolve, reject) => {
      if (this.initialized) {
        return resolve(true);
      }

      this.initialized = true;
      loadScript('//fast.appcues.com/58488.js')
        .then(() => resolve(true))
        .catch(() => {
          this.initialized = false;
          reject(false);
        })

    })
  };

  reset = () => {
    if (appWindow.Appcues) {
      appWindow.Appcues.reset();
    }
  }
}
